import api from 'src/config/api';
import {
	IAnnotation,
	IAnnotationLandmark,
	ICreateAnnotationLandmarkRequest,
	IUpdateAnnotationLandmarkRequest,
	IUpdateAnnotationRequest,
} from 'src/features/annotation/domain/types';
import { IStudyAnnotation } from 'src/features/study';

export const annotationApi = {
	updateAnnotationApi: async (
		annotationId: number,
		requestBody: IUpdateAnnotationRequest,
		siteSlug: string,
	): Promise<IAnnotation> => {
		const response = await api.patch(
			`/api/v1/annotation/${annotationId}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	getStudyImageAnnotation: async (
		studyId: string,
		imageId: number,
		siteSlug: string,
	): Promise<IStudyAnnotation> => {
		const response = await api.get(
			`/api/v1/study/${studyId}/annotation?image_id=${imageId}`,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},
};

export const annotationLandmarkApi = {
	getAnnotationLandmarks: async (
		annotationId: number,
		siteSlug: string,
	): Promise<IAnnotationLandmark[]> => {
		const response = await api.get(
			`/api/v1/annotation/${annotationId}/landmarks`,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	createAnnotationLandmark: async (
		requestBody: ICreateAnnotationLandmarkRequest,
		siteSlug: string,
	): Promise<IAnnotationLandmark> => {
		const response = await api.post(
			`/api/v1/annotation-landmark`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	updateAnnotationLandmark: async (
		annotationId: number,
		requestBody: IUpdateAnnotationLandmarkRequest,
		siteSlug: string,
	): Promise<IAnnotationLandmark> => {
		const response = await api.patch(
			`/api/v1/annotation-landmark/${annotationId}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	deleteAnnotationLandmark: async (
		siteSlug: string,
		annotationId: number,
	): Promise<void> => {
		const response = await api.delete(
			`/api/v1/annotation-landmark/${annotationId}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},
};
